// src/lib/golfcourseapi.js
// Thin client for the GolfCourseAPI proxy function. Server enforces quota +
// caching; the browser never sees the API key. SECONDARY provider — see the
// header in netlify/functions/golfcourseapi.js for the full design rationale.
//
// Practical rule of thumb: try `golfapi` first (POI-rich); if it returns
// `{degraded:true}` or `results:[]`, fall through to `golfcourseapi` here.
// GolfCourseAPI has no per-hole POIs, so a course sourced from it will score
// fine but render the GPS map without an aim line / bullseye.
//
// Authorization (F-091-T1): reads the current Supabase session and attaches a
// Bearer token so the server can derive requested_by from the JWT. Unauth
// callers omit the header; server logs requested_by=NULL.

import { supabase } from './supabase'

export async function golfcourseapi(mode, payload = {}) {
  const headers = { 'Content-Type': 'application/json' }
  try {
    const { data: { session } = {} } = await supabase.auth.getSession()
    if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`
  } catch { /* no session → send unauthed, server logs NULL */ }
  const res = await fetch('/.netlify/functions/golfcourseapi', {
    method: 'POST',
    headers,
    body: JSON.stringify({ mode, ...payload }),
  })
  const json = await res.json()
  if (!res.ok) throw new Error(json.error || `golfcourseapi ${res.status}`)
  return json
}
